import type { Building } from "building-types/building/buildingTypes";
import { getActiveElevation } from "doc/options/activeElevation";
import memo from "../utils/memo";

function select({ doc: { optionSets }, optionChoices }: Pick<Building, "doc" | "optionChoices">) {
  return {
    activeElevationCameraPositions: getActiveElevation({ optionSets }, optionChoices)?.cameraPositions,
  };
}

function generate({
  activeElevationCameraPositions,
}: ReturnType<typeof select>): Pick<Building, "defaultExteriorCamera"> {
  return {
    defaultExteriorCamera: activeElevationCameraPositions?.defaultExteriorCamera,
  };
}

export default memo(select, generate);
